import { render, staticRenderFns } from "./TagSetting.vue?vue&type=template&id=5149dcd9&scoped=true"
import script from "./TagSetting.vue?vue&type=script&lang=js"
export * from "./TagSetting.vue?vue&type=script&lang=js"
import style0 from "./TagSetting.vue?vue&type=style&index=0&id=5149dcd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149dcd9",
  null
  
)

export default component.exports